import React from "react";
import FaqSection from "components/FaqSection";
import GuideSection from "components/GuideSection";
import Link from "next/link";
import SideBar from "./SideBar";
import {
  HeaderH2,
  HeaderH1,
  Text,
  NextButton,
  ImageBlock,
} from "components/TextBlocks";

function SaveTabs(props) {
  const keyCss = {
    fontSize: "1rem",
    fontFamily: "menlo, consolas, monospace",
    border: "1px solid #DDDDDD",
    borderRadius: "5px",
    boxShadow: "0 4px 8px -1px rgba(201,204,208,0.90)",
    backgroundColor: "#FFF",
    paddingTop: "4px",
    paddingBottom: "4px",
    paddingLeft: "7px",
    paddingRight: "6px",
  };
  return (
    <>
      <HeaderH1>Save tabs</HeaderH1>
      <Text>
        Save a tab by hovering your Active tabs list. Drag the tab that you want
        to save and drop it into a group. The tab will be closed and saved.
      </Text>
      <Text>
        If you only need Chrome to remember a native group, start with its
        built-in saved tab groups. Read our{" "}
        <Link href="/blog/how-to-save-tab-groups-in-chrome">
          guide to saving tab groups in Chrome
        </Link>{" "}
        to choose between native groups and a workspace with notes and
        reminders.
      </Text>
      <ImageBlock
        src={"/guide/add_tab_by_drop.png"}
        width={504}
        height={432}
        quality={100}
        alt={"Add tab by drop"}
      />
      <HeaderH2 id="Savealltabs">Save all tabs in window</HeaderH2>
      <Text>
        You can also save all tabs in a given window by going to the dropdown
        menu in the left-hand corner and select "Add X tabs to new group" or
        "Move X tabs into group".
      </Text>
      <ImageBlock
        src={"/guide/move_tabs_into_space.png"}
        width={504}
        height={432}
        quality={100}
        alt={"Move tabs into group"}
      />
      <HeaderH2 id="right-click-save">Right-click and choose group</HeaderH2>
      <Text>
        Finally you can also right-click any website you are on and choose
        "Close site and save to". This will immediately close the tab and save
        it to the chosen group.
      </Text>
      <ImageBlock
        src={"/guide/close_and_save.png"}
        width={504}
        height={372}
        quality={100}
        alt={"Move tabs into group"}
      />
      <NextButton
        cta={"Save images"}
        textColor={"#565D65"}
        bg={"#EBECED"}
        page={"/guide/save-images"}
      />
    </>
  );
}

SaveTabs.Layout = SideBar;

export default SaveTabs;
